<script setup>
import SiteNavigation from './views/SiteNavigation.vue'
</script>
<template>
  <SiteNavigation />
</template>
